import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { WEBVIEW_QUERY_KEY, WebviewPlatform } from './types/webview'

export const useWebview = () => {
  const route = useRoute()

  const isWebview = computed<boolean>(() => {
    return Object.hasOwn(route.query, WEBVIEW_QUERY_KEY)
  })

  const isAndroid = computed<boolean>(() => {
    return route.query.platform === WebviewPlatform.ANDROID
  })

  const isIOS = computed<boolean>(() => {
    return route.query.platform === WebviewPlatform.IOS
  })

  return {
    isWebview,
    isAndroid,
    isIOS
  }
}
